import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Injector} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {CommonService} from '../../../../../../core/services/common.service';
import {Message} from '../../../../../../core/class/message';
import {AutoUserService} from '../../../../../../core/services/auto-user.service';
import {TranslateService} from '@ngx-translate/core';
import {ProcedureService} from '../../../../../../core/services/procedure.service';
import {ContractService} from '../../../../../../core/services/contract.service';
import {LotSignFlowService} from '../../../../../../core/services/lot-sign-flow.service';
import {EnumContractUserRole} from '../../../../../../core/constants/contract';

@Component({
  selector: 'app-setup-sign-flow-lot',
  templateUrl: './setup-sign-flow-lot.component.html',
  styleUrls: ['./setup-sign-flow-lot.component.scss']
})
export class SetupSignFlowLotComponent implements OnInit {
  public listOfDataUserSign: any[] = [];
  inputUserValue: any;
  filteredUserOptions = [];
  isLoadUserSign = false;
  roleUser = EnumContractUserRole;
  valueSelectedUserRole: string = (this.roleUser.APPROVE + '');
  enterpriseId: string;
  isValidNoUserExist = false;
  isValidExistingSigning = false;
  isSaving = false;

  translate: TranslateService;
  searchCtrl: FormControl = new FormControl();
  procedures: any[] = [];
  proceduresFilter: any[] = [];
  procedureId: any = 'no_use_sign_process';

  contractIds: string[] = [];
  contracts: any[] = [];

  constructor(
    private injector: Injector,
    public dialogRef: MatDialogRef<SetupSignFlowLotComponent>,
    public autoUserService: AutoUserService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private message: Message,
    private procedureService: ProcedureService,
    private translateService: TranslateService,
    private contractService: ContractService,
    private lotSignFlowService: LotSignFlowService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.translate = injector.get<TranslateService>(TranslateService);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onNoClick();
    });
    this.contractIds = (data && data.contractIds) || [];
    this.contracts = (data && data.contracts) || [];
  }

  ngOnInit() {
    this.getAllProcedure();
  }

  setFormChanging(changingStatus: boolean): void {
  }

  autocompleteUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedUser(model.id, model.fullName, model.email)) {
        this.listOfDataUserSign = this.listOfDataUserSign.map((item) => {
          return {
            ...item,
            userRole: this.roleUser.APPROVE + ''
          };
        });

        const orderUserSign = this.listOfDataUserSign.length ? this.listOfDataUserSign[this.listOfDataUserSign.length - 1].order + 1 : 1;
        this.listOfDataUserSign = [
          ...this.listOfDataUserSign,
          {
            order: orderUserSign,
            userId: model.id,
            enterpriseId: model.enterpriseId,
            userName: model.fullName,
            userEmail: model.email,
            userRole: this.valueSelectedUserRole,
            userPhone: model.phone,
            enterpriseEmail: null,
            enterpriseName: null,
            taxCode: model.taxCode,
            CTS: model.CTS ? true : false,
            showImage: model.showImage ? true : false
          }
        ];

        this.reorderUserSign();
        this.inputUserValue = '';
        this.isValidNoUserExist = false;
        this.isValidExistingSigning = false;
        this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
      }
    }
  }

  onChangeUserSignSearch(event): void {
    if (this.inputUserValue && this.inputUserValue.trim().length > 0) {
      this.isLoadUserSign = true;
      this.autoUserService.fetchAuto(event)
        .then(result => {
          this.filteredUserOptions = result;
        }).finally(() => {
        this.isLoadUserSign = false;
      });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  checkExistedUser(id: string, fullname: string, email: string) {
    const existedList = this.listOfDataUserSign.filter((e) => {
      return e.userId == id;
    });

    if (existedList.length > 0) {
      this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate'), [fullname + ' - ' + email]));
      return true;
    } else {
      return false;
    }
  }

  private reorderUserSign(): void {
    this.listOfDataUserSign.sort((a, b) => (a.order || 0) - (b.order || 0));
    this.listOfDataUserSign.forEach((item, index) => {
      item.order = index + 1;
    });
  }

  changeRoleUserSign(value: any, data: any) {
    if (value == 1) {
      if (this.listOfDataUserSign.length > 1) {
        this.listOfDataUserSign = [...this.listOfDataUserSign.filter((item) => item.userId !== data.userId)];
        this.listOfDataUserSign = [...this.listOfDataUserSign.map((item) => ({
          ...item,
          userRole: this.roleUser.APPROVE + ''
        }))];
        this.listOfDataUserSign.push({
          ...data,
          order: this.listOfDataUserSign.length + 1,
          userRole: this.roleUser.SIGN + ''
        });
      } else {
        this.listOfDataUserSign = [];
        this.listOfDataUserSign.push({
          ...data,
          order: 1,
          userRole: this.roleUser.SIGN + ''
        });
      }
    }
    this.reorderUserSign();
  }

  changeCTS(data) {
    if (data.CTS) {
      data.CTS = true;
      data.showImage = true;
    } else {
      data.showImage = false;
      data.CTS = false;
    }
  }

  onClickDeleteElementRecordUser(data: any): void {
    this.listOfDataUserSign = this.listOfDataUserSign.filter(d => d.userId !== data.userId);
    this.reorderUserSign();
  }

  onChangeOrderApproveSign() {
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  getAllProcedure() {
    this.procedureService.searchProcedure(
      {
        name: null,
        status: [1],
        type: [2],
        enterpriseId: localStorage.getItem('enterpriseId'),
        page: 0,
        pageSize: 999999999,
        id: null
      }
    ).subscribe(response => {
      if (!response || !response.data) {
        return;
      }
      this.procedures = this.procedures.concat(response.data.dataRow);
      this.proceduresFilter = [{
        id: 'no_use_sign_process',
        procedureName: this.translateService.instant('enterprise_contract.no_use_sign_process')
      }].concat(this.procedures);
    });
  }

  async changeProcedure($event: any) {
    this.procedureId = $event.value;
    if (this.procedureId && this.procedureId !== 'no_use_sign_process') {
      this.getProcedure($event.value);
    } else {
      this.listOfDataUserSign = [...[]];
    }
  }

  getProcedure(procedureId: any) {
    const procedure = this.procedures.find(value => value.id === procedureId);
    this.procedureService.searchProcedureDetails({
      id: procedureId,
      name: procedure ? procedure.procedureName : '',
      status: [1],
      type: [2],
      enterpriseId: localStorage.getItem('enterpriseId'),
      page: 0,
      pageSize: 999999999,
      checkMaxApprover: true,
    }).subscribe(async response => {
      const data = response.data;
      if (!data) {
        this.procedureId = 'no_use_sign_process';
        return;
      }
      if (data.userSign && data.userSign.length) {
        let RECORD_USER_PERFORM_SIGN = [];
        data.userSign.sort((a, b) => {
          return b.role - a.role;
        });
        data.userSign.forEach(el => {
          RECORD_USER_PERFORM_SIGN = [
            ...RECORD_USER_PERFORM_SIGN,
            {
              order: el.order,
              userId: el.id,
              enterpriseId: el.enterpriseId,
              userName: el.name,
              userEmail: el.email,
              userRole: el.role + '',
              userPhone: el.phone,
              enterpriseEmail: null,
              enterpriseName: null,
              taxCode: el.taxCode,
              CTS: el.isSignDigitalCertificate ? true : false,
              showImage: el.signConfig ? this.setDataSignConfig(JSON.parse(el.signConfig)).showImage : true
            },
          ];
        });
        this.listOfDataUserSign = RECORD_USER_PERFORM_SIGN;
        this.reorderUserSign();
      }
    });
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = {...signConfig};
    if (newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = {...newDataSignConfig, resize: false};
    }
    if (newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = {...newDataSignConfig, showImage: true};
    }
    return newDataSignConfig;
  }

  private validateErrorSetUser() {
    if (this.listOfDataUserSign.length == 0) {
      this.isValidNoUserExist = true;
      return true;
    } else {
      this.isValidNoUserExist = false;
    }
    const signers = this.listOfDataUserSign.filter((e) => {
      return e.userRole == this.roleUser.SIGN.toString();
    });
    if (signers.length > 1 || this.listOfDataUserSign[this.listOfDataUserSign.length - 1].userRole != this.roleUser.SIGN.toString()) {
      this.isValidExistingSigning = true;
      return true;
    } else {
      this.isValidExistingSigning = false;
    }
    return false;
  }

  /**
   * Map each selected user to the full structure expected by /sign-lot-flow/setup-internal,
   * with field names matching /contract/update-user-sign-receive (name, email, role, phone...).
   */
  buildContractUsers(): any[] {
    return this.listOfDataUserSign.map(item => ({
      order: item.order,
      userId: item.userId,
      enterpriseId: item.enterpriseId,
      name: item.userName,
      email: item.userEmail,
      role: item.userRole,
      phone: item.userPhone,
      taxCode: item.taxCode,
      isCreatedSide: false,
      isSignDigitalCertificate: item.CTS ? true : false,
      signConfig: ''
    }));
  }

  onsave() {
    if (this.validateErrorSetUser()) {
      this.toastr.error(this.isValidExistingSigning
        ? this.message.getMessage('messages.error_no_user_sign')
        : this.message.getMessage('validation.error_user_no_set_up'));
      return;
    }
    if (!this.contractIds || !this.contractIds.length) {
      this.toastr.error(this.message.getMessage('messages.no_document_wait_setup_flow'));
      return;
    }

    this.isSaving = true;
    this.contractService.updateUserSignReceiveLot(this.contractIds, this.buildContractUsers())
      .subscribe((res) => {
        this.lotSignFlowService.clearData();
        const lotId = res && res.data ? res.data : null;
        this.dialogRef.close(lotId);
      }, () => {
        this.isSaving = false;
      });
  }
}
